import CargoCounterPage from './index'

export default CargoCounterPage